import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const Settings: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">설정</Typography>
      {user && (
        <Box sx={{ mt: 2 }}>
          <Typography>사용자: {user.username}</Typography>
          <Typography>등급: {user.grade}</Typography>
          <Typography>앱: {user.appname}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Settings; 